import { render, staticRenderFns } from "./InvestorRelations.vue?vue&type=template&id=51125383&scoped=true&"
import script from "./InvestorRelations.vue?vue&type=script&lang=js&"
export * from "./InvestorRelations.vue?vue&type=script&lang=js&"
import style0 from "./InvestorRelations.vue?vue&type=style&index=0&id=51125383&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51125383",
  null
  
)

export default component.exports